/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Matching_DivisionInputs */

const th_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่มีดิวิชั่นที่ตรงกับรุ่นอายุและเพศของทีมนี้`)
};

const en_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No division matches this team's age group and gender.`)
};

const ja_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このチームの年齢区分と性別に合うディビジョンがありません。`)
};

const zh_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`没有与这支球队年龄组和性别相符的分区。`)
};

const es_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ninguna categoría coincide con la edad y el género de este equipo.`)
};

const pt_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma categoria corresponde à idade e ao gênero deste time.`)
};

const id_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada divisi yang cocok dengan kelompok usia dan gender tim ini.`)
};

const fr_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune catégorie ne correspond à l’âge et au genre de cette équipe.`)
};

const tl_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang dibisyong tumutugma sa pangkat-edad at kasarian ng team na ito.`)
};

const vi_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không bảng nào khớp nhóm tuổi và giới của đội này.`)
};

const ko_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 팀의 연령대와 성별에 맞는 디비전이 없습니다.`)
};

const de_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Klasse passt zu Altersklasse und Geschlecht dieses Teams.`)
};

const ru_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ни один дивизион не подходит под возраст и пол этой команды.`)
};

const tr_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu takımın yaş grubuna ve cinsiyetine uyan grup yok.`)
};

const it_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessuna categoria corrisponde alla fascia d'età e al genere di questa squadra.`)
};

const pl_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Żadna grupa nie pasuje do kategorii wiekowej i płci tej drużyny.`)
};

const uk_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жоден дивізіон не відповідає віковій групі та статі цієї команди.`)
};

const hi_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस टीम की आयु वर्ग और लिंग से मेल खाता कोई वर्ग नहीं है।`)
};

const ar_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا توجد فئة تطابق الفئة العمرية والجنس لهذا الفريق.`)
};

const ms_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada divisyen sepadan dengan kumpulan umur dan jantina pasukan ini.`)
};

const bn_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই দলের বয়সভিত্তিক শ্রেণি ও লিঙ্গের সঙ্গে কোনও বিভাগ মেলে না।`)
};

const zh_tw2_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沒有符合這支球隊年齡組與性別的分組。`)
};

const zh_hk2_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`沒有符合這支球隊年齡組與性別的組別。`)
};

const ur_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس ٹیم کے عمر گروپ اور جنس سے کوئی درجہ نہیں ملتا۔`)
};

const fa_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هیچ گروهی با ردهٔ سنی و جنسیت این تیم هم‌خوان نیست.`)
};

const sw_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakuna daraja linalolingana na kundi la umri na jinsia ya timu hii.`)
};

const nl_no_matching_division = /** @type {(inputs: No_Matching_DivisionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen klasse past bij de leeftijdsgroep en het geslacht van dit team.`)
};

/**
* | output |
* | --- |
* | "No division matches this team's age group and gender." |
*
* @param {No_Matching_DivisionInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const no_matching_division = /** @type {((inputs?: No_Matching_DivisionInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Matching_DivisionInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_no_matching_division(inputs)
	if (locale === "ja") return ja_no_matching_division(inputs)
	if (locale === "zh") return zh_no_matching_division(inputs)
	if (locale === "es") return es_no_matching_division(inputs)
	if (locale === "pt") return pt_no_matching_division(inputs)
	if (locale === "id") return id_no_matching_division(inputs)
	if (locale === "fr") return fr_no_matching_division(inputs)
	if (locale === "tl") return tl_no_matching_division(inputs)
	if (locale === "vi") return vi_no_matching_division(inputs)
	if (locale === "ko") return ko_no_matching_division(inputs)
	if (locale === "de") return de_no_matching_division(inputs)
	if (locale === "ru") return ru_no_matching_division(inputs)
	if (locale === "tr") return tr_no_matching_division(inputs)
	if (locale === "it") return it_no_matching_division(inputs)
	if (locale === "pl") return pl_no_matching_division(inputs)
	if (locale === "uk") return uk_no_matching_division(inputs)
	if (locale === "hi") return hi_no_matching_division(inputs)
	if (locale === "ar") return ar_no_matching_division(inputs)
	if (locale === "ms") return ms_no_matching_division(inputs)
	if (locale === "bn") return bn_no_matching_division(inputs)
	if (locale === "zh-TW") return zh_tw2_no_matching_division(inputs)
	if (locale === "zh-HK") return zh_hk2_no_matching_division(inputs)
	if (locale === "ur") return ur_no_matching_division(inputs)
	if (locale === "fa") return fa_no_matching_division(inputs)
	if (locale === "sw") return sw_no_matching_division(inputs)
	if (locale === "nl") return nl_no_matching_division(inputs)
	return en_no_matching_division(inputs)
});